import React from 'react';

/**
 * Componente genérico de Modal.
 * Props:
 *  - children: contenido que se renderiza dentro del modal
 *  - onClose: callback para cerrar
 */
export default function Modal({ children, onClose }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white dark:bg-gray-800 p-6 rounded-lg relative max-w-lg w-full"
        onClick={e => e.stopPropagation()}
      >
        {/* Botón de cerrar */}
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          ×
        </button>
        {children}
      </div>
    </div>
  );
}
